<h3 class="h3">
  {{ 'INDUSTRIES.HEADING' | translate }}
</h3>

<div class="pagination-buttons">
  @for (industry of industries; track industry.id; let index = $index) {
    <button
      class="pagination-button"
      [class.active]="activeSlideIndex() === index"
      (click)="goToSlide(index)"
      [attr.aria-label]="'Go to ' + industry.title"
      [attr.aria-current]="activeSlideIndex() === index ? 'true' : 'false'">
      {{ industry.label | translate }}
    </button>
  }
</div>

<div class="industries-carousel swiper">
  <div class="carousel-inner-wrapper swiper-wrapper">
    @for (industry of industries; track industry.id) {
      <app-industry-block class="industry-wrapper swiper-slide"
                          [config]="industry">
      </app-industry-block>
    }
  </div>
</div>

